import { useDispatch, useSelector } from "react-redux";
import { pusher } from "@common/services/socketCommution";
import { reducerPaths } from "../../../../../app/reducerPaths";
import React from "react";
import { Bidding_Through } from "../../../../../utils/constants/auction";

const useListenForNewCarsInNego = ({
  Vehicle_Id,
  onNewBidHandler,
  onNewCarInNegoHandler
}) => {

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const auth = useSelector(store => store[reducerPaths.auth]);
  // useSelector end...

  // Handlers start...
  const onNewCar = (e) => {
    console.log("onNewCar", e);
    if (onNewCarInNegoHandler) {
      onNewCarInNegoHandler(e?.vehicle);
    }
  };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    const channel = pusher.subscribe(`private-notification.${auth?.user_id}`);
    channel.bind(`negotiation.started`, onNewCar);

    return () => {
      channel.unbind(`negotiation.started`, onNewCar);
    }
  }, []);
  // useEffect end...
};  

export {
  useListenForNewCarsInNego
};